import styled, { contentMargins, contentPadding, css, rem, spacingBase } from 'theme';
import boxShadow from 'theme/global/box-shadow';

interface IAlertComponentProps {
  fitContent: boolean;
}

interface IAlertContentProps {
  alternativeLink: boolean;
}

const AlertComponent = styled.section<IAlertComponentProps>`
  position: relative;
  display: flex;
  box-shadow: ${boxShadow.section};
  border-radius: var(--sys-border-radius-sm);
  border-bottom: ${rem(2)} solid;
  ${(p) =>
    p.fitContent &&
    css`
      width: fit-content;
    `};

  ${contentMargins(1, 0, 1, 0)};
`;

export const Icon = styled('div')`
  ${contentPadding()};
  border-top-left-radius: var(--sys-border-radius-sm);
  border-bottom-left-radius: var(--sys-border-radius-sm);
  fill: var(--ref-color-blackwhite-white);
  color: var(--ref-color-blackwhite-white);
  display: flex;
  align-items: center;

  svg {
    width: ${rem(24)};
    height: ${rem(24)};
    vertical-align: middle;
  }
`;

export const Success = styled(AlertComponent)`
  background: var(--ref-color-blackwhite-white);
  ${Icon} {
    background-color: var(--sys-color-success);
  }
  border-color: var(--sys-color-success);
`;

export const Info = styled(AlertComponent)`
  background: var(--ref-color-blackwhite-white);
  ${Icon} {
    background-color: var(--ref-color-aqua-60);
  }
  border-color: var(--ref-color-aqua-60);
`;

export const Error = styled(AlertComponent)`
  background: var(--ref-color-blackwhite-white);
  ${Icon} {
    background-color: var(--sys-color-error);
  }
  border-color: var(--sys-color-error);
`;

export const Warning = styled(AlertComponent)`
  background: var(--ref-color-blackwhite-white);
  ${Icon} {
    background-color: var(--sys-color-primary);
  }
  border-color: var(--sys-color-primary);
`;

export const Content = styled.div<IAlertContentProps>`
  ${contentPadding(1, 1, 1, 1)};
  width: 100%;
  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  span {
    vertical-align: middle;
  }

  a {
    font-weight: var(--ref-font-weight-600);
    text-decoration: underline;
  }

  ${(p) =>
    p.alternativeLink &&
    css`
      a {
        text-decoration: none;
        :hover {
          text-decoration: underline;
        }
      }
    `};
`;

export const CloseIcon = styled('button')`
  position: absolute;
  top: ${() => spacingBase};
  right: ${() => spacingBase};
  padding: ${() => spacingBase};
  align-self: flex-start;
  appearance: none;
  border: none;
  cursor: pointer;
  background: transparent;
`;
